export default __webpack_public_path__ + "static/media/slide3.caf961fe.mp3";